import React from 'react';
import { Gamepad2 } from 'lucide-react';
import { MODE_ICONS, MODE_COLORS, formatDate } from './constants';

const OverviewTab = ({ modeStats, recentScores }) => (
  <div className="space-y-6">
    {/* Mode Breakdown */}
    <div className="glass-card p-5">
      <h2 className="font-game text-sm text-[#14F195] mb-4">STATS BY MODE</h2>
      {modeStats.length === 0 ? (
        <p className="text-[#666] text-sm text-center py-4">No games played yet</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {modeStats.map((ms, i) => {
            const MIcon = MODE_ICONS[ms.mode] || Gamepad2;
            const color = MODE_COLORS[ms.mode] || '#A1A1AA';
            return (
              <div key={i} className="bg-[#111] rounded-lg p-3 border border-[#222]">
                <div className="flex items-center gap-2 mb-2">
                  <MIcon className="w-4 h-4" style={{ color }} />
                  <span className="font-game text-xs" style={{ color }}>{ms.mode}</span>
                </div>
                <div className="grid grid-cols-3 gap-2 text-center">
                  <div><p className="text-[9px] text-[#666]">BEST</p><p className="font-game text-xs text-[#FFD700]">{ms.best_score?.toLocaleString()}</p></div>
                  <div><p className="text-[9px] text-[#666]">GAMES</p><p className="font-game text-xs text-white">{ms.games}</p></div>
                  <div><p className="text-[9px] text-[#666]">KILLS</p><p className="font-game text-xs text-[#FF3B30]">{ms.total_kills}</p></div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>

    {/* Recent Activity */}
    <div className="glass-card p-5">
      <h2 className="font-game text-sm text-[#5AC8FA] mb-4">RECENT GAMES</h2>
      <div className="space-y-2">
        {recentScores.slice(0, 5).map((s, i) => {
          const MIcon = MODE_ICONS[s.game_mode] || Gamepad2;
          const color = MODE_COLORS[s.game_mode] || '#A1A1AA';
          return (
            <div key={i} className="flex items-center justify-between py-2 border-b border-[#1a1a1a]">
              <div className="flex items-center gap-2">
                <MIcon className="w-4 h-4" style={{ color }} />
                <span className="text-white font-game text-sm">{s.score?.toLocaleString()}</span>
                <span className="text-[#666] text-xs">LVL {s.level}</span>
              </div>
              <span className="text-[#666] text-xs">{formatDate(s.created_at)}</span>
            </div>
          );
        })}
        {recentScores.length === 0 && <p className="text-[#666] text-sm text-center py-4">No games yet</p>}
      </div>
    </div>
  </div>
);

export default OverviewTab;
